/* IP pearl: a turning pearl rendered in WebGL.
   Usage: <canvas data-pearl-canvas data-variant="akoya|rose|gold|tahitian|silver" data-spin="0.35">
   Surface is procedural (nacre bands, fine grain, a few blemishes) and rotates with the sphere;
   light and reflections stay fixed, so the turn reads as a real object. No dependencies. */
(function () {
  var VARIANTS = {
    akoya:    { base: [0.99, 0.97, 0.935], shade: [0.58, 0.53, 0.57], f1: [1.0, 0.76, 0.86], f2: [0.74, 0.93, 0.96], film: 0.30 },
    rose:     { base: [0.98, 0.87, 0.85], shade: [0.62, 0.44, 0.48], f1: [1.0, 0.70, 0.76], f2: [1.0, 0.86, 0.70], film: 0.22 },
    gold:     { base: [0.93, 0.79, 0.50], shade: [0.50, 0.34, 0.16], f1: [1.0, 0.86, 0.50], f2: [0.70, 0.90, 0.60], film: 0.20 },
    tahitian: { base: [0.36, 0.40, 0.42], shade: [0.04, 0.06, 0.07], f1: [0.30, 0.86, 0.62], f2: [0.66, 0.36, 0.88], film: 0.55 },
    silver:   { base: [0.86, 0.90, 0.95], shade: [0.40, 0.47, 0.60], f1: [0.66, 0.80, 1.0], f2: [0.86, 0.70, 1.0], film: 0.28 }
  };

  var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform vec2 uRes;uniform float uTime;uniform vec2 uLight;uniform float uSeed;',
    'uniform vec3 uBase,uShade,uF1,uF2;uniform float uFilm;',
    'float h(vec3 p){p=fract(p*.3183099+.1);p*=17.;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}',
    'float noise(vec3 x){vec3 i=floor(x),f=fract(x);f=f*f*(3.-2.*f);',
    ' return mix(mix(mix(h(i),h(i+vec3(1,0,0)),f.x),mix(h(i+vec3(0,1,0)),h(i+vec3(1,1,0)),f.x),f.y),',
    '            mix(mix(h(i+vec3(0,0,1)),h(i+vec3(1,0,1)),f.x),mix(h(i+vec3(0,1,1)),h(i+vec3(1,1,1)),f.x),f.y),f.z);}',
    'float fbm(vec3 x){float a=.5,s=0.;for(int i=0;i<4;i++){s+=a*noise(x);x*=2.03;a*=.5;}return s;}',
    'vec3 pal(float t,vec3 a,vec3 b){return mix(a,b,.5+.5*sin(6.2832*t));}',
    'vec3 env(vec3 r){',
    ' float up=clamp(r.y*.5+.5,0.,1.);',
    ' vec3 c=mix(vec3(.30,.31,.36),vec3(.92,.93,.97),up);',               /* soft sky gradient */
    ' vec2 w=(r.xy-vec2(-.34,.36))/vec2(.42,.26);',                        /* large window, upper left */
    ' float win=1.-smoothstep(.78,1.,max(abs(w.x),abs(w.y)));win*=step(0.,r.z+.35);',
    ' vec2 s=(r.xy-vec2(.52,-.18))/vec2(.07,.46);',                         /* narrow strip, right */
    ' float st=1.-smoothstep(.7,1.,max(abs(s.x),abs(s.y)));',
    ' return c+vec3(1.)*win*.85+vec3(.95,.97,1.)*st*.35;}',
    'void main(){',
    ' vec2 uv=(gl_FragCoord.xy*2.-uRes)/min(uRes.x,uRes.y);float r2=dot(uv,uv);',
    ' float edge=1.-smoothstep(.985,1.,sqrt(r2));if(edge<=0.){gl_FragColor=vec4(0.);return;}',
    ' float nz=sqrt(max(0.,1.-min(r2,1.)));vec3 n=vec3(uv,nz);',
    ' float a=uTime;float ca=cos(a),sa=sin(a),ct=.93,st=.37;',               /* spin about a tilted axis */
    ' vec3 o=vec3(ca*n.x+sa*n.z,n.y,-sa*n.x+ca*n.z);',
    ' o=vec3(o.x,ct*o.y-st*o.z,st*o.y+ct*o.z);o+=uSeed;',
    ' vec3 L=normalize(vec3(uLight,.8));',
    ' float d=max(dot(n,L),0.);d=.34+.66*pow(d,.85);',
    ' float grain=fbm(o*7.)*.5+fbm(o*26.)*.5;',
    ' float band=sin(o.y*11.+fbm(o*2.5)*5.);',
    ' float ph=band*.30+fbm(o*2.2)*1.5+n.z*.9+uSeed;',
    ' float fr=pow(1.-nz,2.2);',
    ' float film=uFilm*(.45+.55*fr);',
    ' vec3 col=mix(uShade,uBase,d);',
    ' vec3 tint=pal(ph,uF1,uF2);col=mix(col,col*.55+tint*.62,clamp(film,0.,1.));',
    ' col*=.975+.05*grain;',
    ' float spots=smoothstep(.88,.96,noise(o*30.));col*=1.-spots*.045;',     /* tiny blemishes */
    ' vec3 R=2.*nz*n-vec3(0.,0.,1.);',
    ' float fres=.03+.30*pow(1.-nz,3.);',
    ' vec3 e=env(R);col=mix(col,e*mix(vec3(1.),tint,.3),fres+.045);',
    ' col+=e*(.05+.07*grain)*0.5;',
    ' vec3 H=normalize(L+vec3(0.,0.,1.));float sp=pow(max(dot(n,H),0.),70.);col+=vec3(1.)*sp*.7;',
    ' float rim=pow(1.-nz,4.)*max(0.,dot(normalize(n.xy+1e-4),-L.xy));col+=vec3(1.,.86,.9)*rim*.22;',
    ' col=pow(clamp(col,0.,1.),vec3(.95));',
    ' gl_FragColor=vec4(col*edge,edge);}'
  ].join('\n');

  function compile(gl, type, src) {
    var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { if (window.console) console.warn(gl.getShaderInfoLog(s)); return null; }
    return s;
  }

  function mount(cv) {
    var gl = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: true });
    if (!gl) return fallback(cv);
    var vs = compile(gl, gl.VERTEX_SHADER, VS), fs = compile(gl, gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return fallback(cv);
    var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return fallback(cv);
    gl.useProgram(pr);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var U = {}; ['uRes', 'uTime', 'uLight', 'uSeed', 'uBase', 'uShade', 'uF1', 'uF2', 'uFilm'].forEach(function (k) { U[k] = gl.getUniformLocation(pr, k); });

    var v = VARIANTS[cv.getAttribute('data-variant')] || VARIANTS.akoya;
    var spin = parseFloat(cv.getAttribute('data-spin') || '0.32');
    var seed = parseFloat(cv.getAttribute('data-seed') || '0.37');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lx = -0.3, ly = 0.4, tlx = -0.3, tly = 0.4, t = reduce ? 0.9 : 0, last = 0, visible = true, raf = 0;

    function size() {
      var d = Math.min(window.devicePixelRatio || 1, 2), w = Math.max(2, Math.round(cv.clientWidth * d)), h = Math.max(2, Math.round(cv.clientHeight * d));
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      gl.viewport(0, 0, w, h);
    }
    function frame(now) {
      raf = 0;
      var dt = last ? Math.min(0.1, (now - last) / 1000) : 0; last = now;
      if (!reduce) t += dt * spin;
      lx += (tlx - lx) * 0.06; ly += (tly - ly) * 0.06;
      size();
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform2f(U.uRes, cv.width, cv.height); gl.uniform1f(U.uTime, t); gl.uniform2f(U.uLight, lx, ly); gl.uniform1f(U.uSeed, seed);
      gl.uniform3fv(U.uBase, v.base); gl.uniform3fv(U.uShade, v.shade); gl.uniform3fv(U.uF1, v.f1); gl.uniform3fv(U.uF2, v.f2); gl.uniform1f(U.uFilm, v.film);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (!reduce && visible && !document.hidden) raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) kick(); }).observe(cv);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    window.addEventListener('resize', kick);
    if (!reduce) window.addEventListener('pointermove', function (e) {
      tlx = Math.max(-0.8, Math.min(0.8, (e.clientX / window.innerWidth - 0.5) * 1.8 - 0.1));
      tly = Math.max(-0.8, Math.min(0.8, -(e.clientY / window.innerHeight - 0.5) * 1.8 + 0.1));
    }, { passive: true });
    kick();
  }

  function fallback(cv) { cv.classList.add('pearl--static'); }

  function init() { var l = document.querySelectorAll('[data-pearl-canvas]'); for (var i = 0; i < l.length; i++) mount(l[i]); }
  window.IPPearl = { mount: mount, init: init, variants: Object.keys(VARIANTS) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
